module.exports = __webpack_public_path__ + "static/img/shengWuYiYao.787fc5a3.jpg";